






































































































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignContactDto from '@/models/CampaignContacts/CampaignContactDto';
import CampaignContactStatus from '@/components/CampaignContacts/Display/CampaignContactStatus.vue'
import CampaignContactStatusEnum from '@/models/CampaignContacts/CampaignContactStatus';
import ContactStatus from '@/components/Contacts/Display/ContactStatus.vue';
import CampaignStatusEnum from '@/models/Campaigns/CampaignStatus';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'CampaignContact',
  components: { ContactStatus, CampaignContactStatus }
})
export default class extends GiganautVue {

	campaignContactStatusEnum = CampaignContactStatusEnum;
	campaignStatusEnum = CampaignStatusEnum;
	page = 1;
	perPage = 8;

	// Preview dialog state
	previewDialogVisible = false;
	previewSubject = '';
	previewBodyHtml = '';
	loadingPreview = false;
	
	@Prop({required: true})
	tab: string;

	tabLocal = '';

	@Prop({required: true})
	parentTab: string;

	@Prop({required: true})
	campaignContact: CampaignContactDto;

	get campaign() {
		return CampaignDetailsModule.currentCampaign;
	}

	async beforeMount() {
		this.tabLocal = this.tab;
	}

	get loadingContact() {
		return false;//return CampaignDetailsModule.loadingContact;
	}

	async removeContactFromAudience() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "REMOVE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to remove this contact from the audience?', options);
        if (result) {
            await CampaignDetailsModule.deleteCampaignContact(this.campaignContact.id);
        }
    }

	async testCampaignContactEmail() {
		const options: VuetifyConfirmObject = {
            buttonTrueText: "SEND",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('This will send the email to your email address for review. Would you like to send?', options);
        if (result) {
			await CampaignDetailsModule.testCampaignContactEmail();
        }
	}

	async previewCampaignContactEmail() {
		this.previewDialogVisible = true;
		this.loadingPreview = true;
		this.previewSubject = '';
		this.previewBodyHtml = '';

		const preview = await CampaignDetailsModule.previewCampaignContactEmail();
		if (preview) {
			this.previewSubject = preview.subject;
			this.previewBodyHtml = preview.bodyHtml;
		}
		this.loadingPreview = false;
	}
}
